module.exports = __webpack_public_path__ + "static/media/signalSoundTest.2a7201bc.wav";